<template>
	<div class="tab-pane" :class="{ active: defaultTab, show: defaultTab }" :id="id">
		<div class="row p-4 b-b _600 nav-title">
            <div class="col-md-9">
            Test Designer
            </div>
        <div class="col-md-3">
        <div @click="Preview = !Preview" class="btn button button1 d-flex  p-2 justify-content-center">
             <span v-if="Preview" >Exit Preview</span><span v-if="!Preview" >Preview</span>
        </div>
        </div>

        </div>
        <test-viewer
        v-if="Preview"
            id="tab-5"
            :assessment="assessment"
			:forPreview="true"
        ></test-viewer>
		<div v-if="!Preview" role="form" class="col-12 col-lg-12">
			<div class="row m-0 pt-4">
				<div class="col-12">
					<div v-for="(element,index) in assessment.test" v-bind:key="index" class="form-group">
                        <div class="row">
                        <div class="col-md-10">
						<RichText
							:text.sync="assessment.test[index]"
							:initial="originalDesc[index]"
							:options="{ height: 140 }"
							:refresh="refresh"
							class="border"
						></RichText>
                        </div>
                        <div class="col-md-2">
                            <div @click="Delete(index)" class="btn btn-danger d-flex p-2 justify-content-center">
                                Delete
                            </div>
							<br>
							<label class="md-check">
								<input
									type="checkbox" v-model="assessment.student_notes[index]">
								<i class="theme-accent"></i> Student preview
							</label>
                        </div>

                        </div>


					</div>
				</div>
			</div>
			<div class="row m-0 pt-4 bott">
				<div class="col-12 text-center">
					<div @click="addRichText()" class="btn button button1 d-flex p-2 justify-content-center">
                            Add New RichText
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.margin-overlap {
	margin-right: -2.5rem;
}
.button {
  background-color: #4CAF50; /* Green */
  border: none;
  color: white;
  padding: 16px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  transition-duration: 0.4s;
  cursor: pointer;
}

.button1 {
  background-color: white; 
  color:  #4CAF50; 
  border: 2px solid #4CAF50;
}

.button1:hover {
  background-color: #4CAF50;
  color: white;
}
.bott{
    padding-bottom: 30px ;
}
</style>

<script>
import EditPane from "@/components/EditPane";
import SaveOptionalModal from "@/components/SaveOptionalModal";
import ConfigSelect from "@/components/ConfigSelect";
import RichText from "@/components/RichText";
import TestViewer from "@/components/assessment/TestViewer";

import AssessmentService from "@/services/AssessmentService";
import ContentAreaService from "@/services/ContentAreaService";
import GradeService from "@/services/GradeService";
import ValidationService from "@/services/ValidationService";
import Notie from "@/services/NotieService";
import fs from "@/services/FormatService";
import BB from "bluebird";
import Utils from "@/services/Utils";
import draggable from "vuedraggable";
import ConfigItemSearch from "@/components/ConfigItemSearch";

export default {
	name: "TestDesigner",

	props: ["id", "assessment", "defaultTab", "valid"],

	components: {
		"test-viewer": TestViewer,
		EditPane,
		SaveOptionalModal,
		ConfigSelect,
		ConfigItemSearch,
		RichText,
		draggable
	},

	data() {
		return {
			fs: fs,
            ntests : 0,
			originalDesc: [],
			student_notes:[],
			refresh: null,
            Preview:false,
			dirty: false,
			saveOptModal: false,
			saveOptNext: () => {},
			saveOptCancel: () => {}
		};
	},

	computed: {

	},

	created() {
		console.log("creating designer")
        if(this.assessment.test){
            for(let element of this.assessment.test ){
                this.originalDesc.push(element)
            }
            this.ntests = this.assessment.test.length
        }
        else{
            this.assessment.test = []
            this.ntests = 0
        }

    },

	watch: {
        assessment(newVal){
            console.log("TEST CHANGED ")

		},
		test(newVal){
			console.log("test",newVal)
		},
		Preview(newVal){
			this.originalDesc = []
			for(let element of this.assessment.test ){
                this.originalDesc.push(element)
            }
		},
		student_notes(newVal){
			console.log(newVal)
			this.assessment.student_notes = newVal
		}

	},

	beforeRouteLeave(to, from, next) {
		if (this.dirty) {
			this.saveOptNext = () => {
				next();
			};
			this.saveOptCancel = () => {
				next(false);
			};
			this.saveOptModal = true;
		} else {
			next();
		}
	},

	methods: {

        addRichText(){
            this.originalDesc.push("")
			this.assessment.test.push("")
			this.assessment.student_notes.push(false)
            this.ntests = this.ntests + 1
            console.log("added new test",this.ntests)
            this.Preview = true
            this.Preview = false


        },
        Delete(index){
            this.originalDesc.splice(index,1)
            this.assessment.test.splice(index,1)
			this.ntests = this.ntests - 1
			this.assessment.student_notes.splice(index,1)
        },
		watchChanges() {
			if (this.unwatch) {
				this.unwatch();
			}
			this.unwatch = this.$watch(
				"assessment",
				(newc, old) => {
					this.dirty = true;
				},
				{ deep: true }
			);
		},


		canSave() {
			return this.dirty;
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/assessment/TestDesigner.vue